// extracted by mini-css-extract-plugin
export default {"dialog":"rwisftQxaDMmIlN9","body":"ZzctYyf3cp3JM5vC","header":"iovye5Duqc0z4xpO","title":"ipz4sGGtIxOp6zlX","subTitle":"zgyZoRvE5wL7W42K"};